import React,{useState,useEffect} from 'react'
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Label,
    Button,
    DropdownToggle,
    DropdownItem,
    DropdownMenu,
    ButtonDropdown,
} from "reactstrap";
import  AsyncCreatable from 'react-select/async-creatable';
import { useSelector,useDispatch } from 'react-redux';
import { sendToNewNumbers, setChatPhone,fetchContacts,fetchMessages,fetchChat } from '../../redux/action';
import { apiCall } from '../../functions/utils';
export default function NewMessageModal({isVisible=true,toggle,number=null}) {
  
  const dispatch=useDispatch()
  const customMessages=useSelector((state)=>state.customMessages) 
  const messages=useSelector((state)=>state.messages) 
  const contacts=useSelector((state)=>state.contacts)
  const [options,setOptions]=useState([])
  const [newNumber,setNewNumber]=useState([number])
  const [textMessage,setTextMessage]=useState('')
  const [btnDropup,setBtnDropup]=useState(false)

  const onSelectChange=(value)=>{
    setNewNumber(value)
   }

   const handleBlur=(e)=>{
    if(e.target.value.length>0){
    let newObj={
      label: e.target.value,
      value: e.target.value,
    };
   setNewNumber([...newNumber,newObj])
  }
  }

  const getOptions=()=>{
    let opts=[]
    contacts.data.map( item => {
        opts.push({ value: item.phone_no, label: item.full_name })
    })
    setOptions([...opts])
  
  }

  const sendMessage=()=>{
    if(newNumber.length<1 || textMessage==='')
    return
    dispatch(sendToNewNumbers(textMessage,newNumber))

    dispatch(fetchMessages())
    //dispatch(setChatPhone(messages.length > 0 && messages.data[0].sender_phone))
    dispatch(fetchChat())
  }

  const getContacts=()=>{
    dispatch(fetchContacts())
  }

  useEffect(()=>{
    setTextMessage("")
      setNewNumber([number])

    },[isVisible==true])

  useEffect(()=>{
    getContacts()

  //  getOptions()
   
  },[])

  useEffect(()=>{
    getOptions()
  },[contacts])


  const promiseOptions = async(inputValue,callback) =>{
   
     const res = await apiCall(true, "GET", `/api/contacts?query=${inputValue}&page=1`)
     let options = []
     if( res && res.data && res.data.data ){
         res.data.data.map( item => {
             options.push({ value: item.phone_no, label: item.full_name })
         })
     }
     callback( options )
 }
  return (
    <Modal isOpen={isVisible} toggle={toggle} >
            <ModalHeader>
                New Message
            </ModalHeader>
            <ModalBody>
                <Label className="mt-2">
                    To:
                </Label>
                <AsyncCreatable style={{marginTop:'0px'}}
                   defaultOptions={ options } 
                    isMulti
                    //ref={s => this.creatable = s}
                    value={newNumber}
                    defaultValue={newNumber}
                    onBlurResetsInput={false}
                    onBlur={handleBlur}
                    placeholder=''
                    onChange = { onSelectChange }
                    loadOptions={promiseOptions}
                    formatCreateLabel={(userInput) => `Add  ${userInput}`}
                />
                <Label>
                    Message
                </Label>
                <textarea
                    // name = "text_message"
                    className={"form-control"}
                   // ref={c=>this.textarea=c}
                    
                    value = {textMessage }
                    rows={3} 
                    onChange = {(e)=>setTextMessage(e.target.value)}
                />

                <ButtonDropdown
                    direction="up"
                    className="mt-2"
                    // color="primary" 
                    style={{borderRadius: '2em !important'}}

                   isOpen={btnDropup}
                   toggle={() => {
                    setBtnDropup(old=>!old)
                    }}
                  >
                    <DropdownToggle caret size="sm" className=" mr-1"  style={{backgroundColor:'#5C5BE3'}}  >
                    {/* <i className="simple-icon-arrow-up" /> */}
                      Template
                    </DropdownToggle>

                    <DropdownMenu style={{maxHeight:"21em", overflowY: "scroll", bottom:"1em",}}>
                      { customMessages.templates.length>0 && customMessages.templates.map( item => {
                        return(
                          <DropdownItem key={item.id} onClick={()=>setTextMessage(item.text_message)}
                          >
                            {item.name}
                          </DropdownItem>
                        )
                      } )}
                      
                    </DropdownMenu>
                  </ButtonDropdown>

        </ModalBody>
          
        <ModalFooter>
            <Button  style={{backgroundColor:'#5C5BE3'}} onClick={()=>{sendMessage();toggle()}}>
                Send
            </Button>{" "}
            <Button color="secondary" 
             onClick={toggle}
            >
                Cancel
            </Button>
        </ModalFooter>
    </Modal>
  )
}
